import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
const MapControlsContainer = ({ children }) => {
    return (_jsx("div", { className: "absolute top-2.5 right-14 z-[1000] flex items-center justify-between gap-x-4", children: children }));
};
MapControlsContainer.propTypes = {
    children: PropTypes.node,
};
export default MapControlsContainer;
